<template>
  <v-dialog v-model="displayForm" persistent max-width="980px">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card>
        <v-card-title>
          <span class="headline" v-if="item">Update Customer</span>
          <span class="headline" v-else>Add Customer</span>
        </v-card-title>
        <div class="text-xs-center">
          <v-progress-circular
            indeterminate
            color="accent"
            v-if="loading"
          ></v-progress-circular>
        </div>
        <v-card-text v-if="!loading">
          <v-alert
            :value="message"
            type="error"
            dismissible
            transition="scale-transition"
            >{{ message }}</v-alert
          >
          <v-row>
            <v-col cols="4">
              <v-checkbox
                v-model="customer.statusId"
                label="Active ?"
                :true-value="1"
                v-bind:false-value="-1"
              ></v-checkbox>
            </v-col>
            <v-col>
              <v-select
                  :items="howLearnDomaValues"
                  label="How did you learn about DomaGolf"
                  v-model="customer.how_learn_doma"
                  :rules="mandatoryRules"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <shop-select
                v-model="customer.shopId"
                :rules="mandatoryRules"
              ></shop-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="customer.company"
                label="Company"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="customer.lastname"
                label="Last name"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="customer.firstname"
                label="First name"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="customer.email"
                label="Email"
                :rules="mandatoryRules"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="customer.mobile"
                label="Mobile"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="customer.phone"
                label="Other Phone"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-text-field
                v-model="customer.tvaNumber"
                label="TVA Number"
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                :items="dominantHands"
                label="Dominant Hand"
                v-model="customer.dominantHand"
              ></v-select>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="customer.handicap"
                label="Handicap"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-radio-group
                v-model="customer.preferedContactMethod"
                label="Prefered Contact Method"
              >
                <v-radio label="Phone" value="phone"/>
                <v-radio label="Email" value="email"/>
                <v-radio label="Text" value="text"/>
              </v-radio-group>
            </v-col>
            <!-- v-col cols="4">
              <v-radio-group
                v-model="customer.newsletter"
                label="Accept Communication"
                :rules="[newsletterRule]"
              >
                <v-radio label="Yes" :value="true" />
                <v-radio label="No" :value="false" />
              </v-radio-group>
            </v-col -->
            <v-col cols="4">
              <v-textarea
                v-model="customer.comments"
                label="Comments"
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row v-if="!item">
            <v-col cols="6">
              <v-card flat>
                <v-card-title>Shipping Address</v-card-title>
                <v-card-text>
                  <v-row wrap>
                    <v-col cols="12">
                      <v-text-field
                        v-model="shippingAddress.company"
                        label="Company"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="shippingAddress.addressLine1"
                        label="Address Line 1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="shippingAddress.addressLine2"
                        label="Address Line 2"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="shippingAddress.city"
                        label="City"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="shippingAddress.state"
                        label="State"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="shippingAddress.postalCode"
                        label="Postal Code"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <country-autocomplete
                        v-model="shippingAddress.country"
                        label="Country"
                      ></country-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
              
            </v-col>
            <v-col cols="6">
              <v-card flat>
                <v-card-title>Billing Address</v-card-title>
                <v-card-text>
                  <v-row wrap>
                    <v-col cols="12">
                      <v-text-field
                        v-model="billingAddress.company"
                        label="Company"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="billingAddress.addressLine1"
                        label="Address Line 1"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="billingAddress.addressLine2"
                        label="Address Line 2"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="billingAddress.city"
                        label="City"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="billingAddress.state"
                        label="State"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="billingAddress.postalCode"
                        label="Postal Code"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <country-autocomplete
                        v-model="billingAddress.country"
                        label="Country"
                      ></country-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="cancel()"
            :disabled="loading"
            >Cancel</v-btn
          >
          <v-btn
            v-if="item"
            color="blue darken-1"
            text
            @click="update()"
            :disabled="loading"
            >Update</v-btn
          >
          <v-btn
            v-else
            color="blue darken-1"
            text
            @click="add()"
            :disabled="loading"
            >Add</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
function getDefaultData() {
  return {
    customer: {
      statusId: -1,
      genderId: null,
      lastname: null,
      firstname: null,
      email: null,
      mobile: null,
      phone: null,
      tvaNumber: null,
      preferedContactMethod: null,
      dominantHand: null,
      handicap: 0,
      comments: null,
      company: null,
      shopId: null,
      newsletter:false
    },
    shippingAddress: {},
    billingAddress: {},
    valid: null,
    emailRules: [
      (v) => !!v || "This fiels is mandatory",
      v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
    ],
    mandatoryRules: [(v) => !!v || "This fiels is mandatory"],
    newsletterRule: (v) => (v===true || v===false) || "This fiels is mandatory",
    genders: [
      { value: 1, text: "Male" },
      { value: 2, text: "Female" },
    ],
    dominantHands: [
      { value: "", text: "Both" },
      { value: "rh", text: "Right Handed" },
      { value: "lh", text: "Left Handed" },
    ],
    howLearnDomaValues: [
      { value: "Email", text: "Email" },
      { value: "Facebook", text: "Facebook" },
      { value: "Golf Pro / Instructor / Facility", text: "Golf Pro / Instructor / Facility" },
      { value: "Google", text: "Google" },
      { value: "Instagram", text: "Instagram" },
      { value: "Tournament / Event", text: "Tournament / Event" },
      { value: "Word of mouth", text: "Word of mouth" },
      { value: "Other", text: "Other" },
    ],
    message: null,
  };
}
import CountryAutocomplete from "@components/forms/autocomplete/Country.vue";
import ShopSelect from "@components/forms/select/Shop.vue";
import { mapActions, mapGetters } from "vuex";
export default {
  components: {
    ShopSelect,
    CountryAutocomplete,
  },
  props: ["item", "open"],
  data: getDefaultData,
  computed: {
    ...mapGetters('clients', ['loading']),
    displayForm: function() {
      return this.open;
    },
  },
  watch: {
    item: function(newVal) {
      Object.assign(this.customer, newVal);
    },
  },
  methods: {
    ...mapActions('clients', {createClient: 'add', updateClient: 'update'}),
    ...mapActions('clientAddresses', {createAddresse: 'add'}),
    add() {
      if (this.$refs.form.validate()) {
        this.createClient(this.customer)
        .then(({client}) => {
          let createShippingAddress;
          let createBillingAddress;
          if(Object.keys(this.shippingAddress).length){
            this.shippingAddress.clientId=client.id
            this.shippingAddress.typeId='shipping'
            createShippingAddress = this.createAddresse({model: this.shippingAddress})
          }
          if(Object.keys(this.billingAddress).length){
            this.billingAddress.clientId=client.id
            this.billingAddress.typeId='billing'
            createBillingAddress = this.createAddresse({model: this.billingAddress})
          }
          Promise.all([createShippingAddress, createBillingAddress])
            .then(() => {
              this.$emit("add", client);
              this.resetForm();
            })
        })
      }
    },
    update() {
      if (this.$refs.form.validate()) {
        this.updateClient(this.customer)
        .then(() => {
            this.$emit("update");
            this.resetForm();
        });
      }
    },
    cancel() {
      this.$emit("cancel");
      this.resetForm();
    },
    resetForm() {
      Object.assign(this.$data, getDefaultData());
      this.$refs.form.reset();
    },
  },
};
</script>

<style></style>
